module.exports = __webpack_public_path__ + "web_static/img/video1.3bd5d3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/assets/video1.jpg
// module id = PyrL
// module chunks = 10